import { render, staticRenderFns } from "./platform_other_account_list.vue?vue&type=template&id=67d6402d&scoped=true"
import script from "./platform_other_account_list.vue?vue&type=script&lang=js"
export * from "./platform_other_account_list.vue?vue&type=script&lang=js"
import style0 from "./platform_other_account_list.vue?vue&type=style&index=0&id=67d6402d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d6402d",
  null
  
)

export default component.exports